<template>
    <div>
        <action-sidebar :title="title" :value="true" @close-modal="closeModal">
            <v-layout wrap pa-5>

                <v-flex xs12 pb-3>
                    <v-select background-color="white" class="body-1" box hide-details label="Entorno"
                        :items="environments" v-model="$v.model.environment.$model"
                        :error="$v.model.environment.$error"></v-select>
                </v-flex>

                <v-flex xs12 pb-3>
                    <v-text-field background-color="white" box class="body-1" hide-details
                        label="Tipo de Recurso (Ej. IMAGE)" v-model="$v.model.resourceType.$model"
                        :error="$v.model.resourceType.$error">
                    </v-text-field>
                </v-flex>

                <!-- Archivo Principal -->
                <v-flex xs12 pb-3>
                    <v-layout align-center>
                        <v-text-field background-color="white" box class="body-1" hide-details
                            label="URL del Archivo (Imagen / PDF)" v-model="$v.model.fileUrl.$model"
                            :error="$v.model.fileUrl.$error">
                        </v-text-field>
                        <upload-image class="ml-3" button-title="Subir" input-id="upload-file-url"
                            label-for="upload-file-url" label-ref="uploadFileUrlRef" :allowed-max-size="4000" @send-image="setFileUrl"
                            @send-file="setFileUrl"></upload-image>
                    </v-layout>
                </v-flex>

                <!-- Archivo Alternativo -->
                <v-flex xs12 pb-3>
                    <v-layout align-center>
                        <v-text-field background-color="white" box class="body-1" hide-details
                            label="URL Alternativa (Opcional)" v-model="model.alternateFileUrl">
                        </v-text-field>
                        <upload-image class="ml-3" button-title="Subir" input-id="upload-alt-url"
                            label-for="upload-alt-url" label-ref="uploadAltUrlRef" :allowed-max-size="4000" @send-image="setAlternateFileUrl"
                            @send-file="setAlternateFileUrl"></upload-image>
                    </v-layout>
                </v-flex>

                <v-flex xs12 pb-3>
                    <v-text-field background-color="white" box class="body-1" hide-details
                        label="URL de Acción / Enlace (Opcional)" v-model="model.actionUrl">
                    </v-text-field>
                </v-flex>

                <v-flex xs12 pb-3>
                    <v-text-field background-color="white" box class="body-1" hide-details
                        label="Orden de visualización" type="number" v-model="model.order">
                    </v-text-field>
                </v-flex>

            </v-layout>

            <section class="modal-filter-footer">
                <modal-sidebar-button :is-loading="$v.$invalid || loading" @accept-button-clicked="saveService"
                    @cancel-button-clicked="closeModal">
                </modal-sidebar-button>
            </section>
        </action-sidebar>
    </div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import uploadImage from '@/components/shared/upload-image'; // Asegúrate de que esta ruta sea la correcta en tu proyecto
import { required } from 'vuelidate/lib/validators';

function closeModal() {
    this.goTo('page-promotion-details', { params: { id: this.id } });
}

async function saveService() {
    const method = this.detailId ? 'patch' : 'post';
    const url = this.detailId ? `promotion-detail/${this.detailId}` : 'promotion-detail';
    const message = this.detailId ? 'modificó' : 'creó';

    try {
        this.model.order = Number(this.model.order) || 0;
        this.model.promotionId = Number(this.id);

        await this.$http[method](url, this.model, { headers: this.headers });
        this.showNotification(`Se ${message} el detalle correctamente.`);
        this.closeModal();
    } catch (error) {
        this.showError();
    }
}

function title() {
    const action = 'Banner / Detalle';
    return this.detailId ? `Editar ${action}` : `Nuevo ${action}`;
}

async function loadData() {
    if (!this.detailId) return;

    try {
        const response = await this.$http.get(`promotion-detail/${this.detailId}`, { headers: this.headers });
        this.model = response.data.data;
    } catch (error) {
        this.showError();
    }
}

// Recibe la respuesta del componente upload-image y la asigna a fileUrl
function setFileUrl(payload) {
    // Si es imagen, viene como payload.urlImage; si es pdf, viene como payload.file
    this.model.fileUrl = payload.urlImage || payload.file;
}

// Recibe la respuesta del componente upload-image y la asigna a alternateFileUrl
function setAlternateFileUrl(payload) {
    this.model.alternateFileUrl = payload.urlImage || payload.file;
}

function created() {
    this.loadData();
}

function validations() {
    return {
        model: {
            environment: { required },
            resourceType: { required },
            fileUrl: { required },
        },
    };
}

function data() {
    return {
        headers: { Accept: `${process.env.ACCEPT_SERVICE_V2}` },
        loading: false,
        environments: ['WEB', 'POS', 'MOBILE'],
        model: {
            promotionId: this.id,
            environment: 'WEB',
            resourceType: 'IMAGE',
            fileUrl: null,
            alternateFileUrl: null,
            actionUrl: null,
            order: 0,
        },
    };
}

export default {
    name: 'page-new-promotion-detail',
    data,
    components: {
        actionSidebar,
        uploadImage,
    },
    created,
    computed: {
        title,
    },
    methods: {
        closeModal,
        loadData,
        saveService,
        setFileUrl,
        setAlternateFileUrl,
    },
    props: {
        id: {
            type: [Number, String],
        },
        detailId: {
            type: [Number, String],
        },
    },
    validations,
};
</script>


// WEBPACK FOOTER //
// src/pages/promotions-details/page-new-promotion-detail.vue